/** An unrecognized address must not invite sign-in to a guessed company. */
export function UnsupportedHost() {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <section className="max-w-md text-center">
        <h1 className="text-2xl font-semibold">This portal address is unavailable</h1>
        <p className="mt-4">Open the portal using the link in your invitation.</p>
      </section>
    </main>
  );
}
